var _g, _mask, _path, _mask2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieChartImg = function SvgPieChartImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 84,
    fill: "none",
    "aria-labelledby": "pitChart"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#PieChartImg_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "PieChartImg_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.667 41c0 21.54-17.461 39-39 39s-39-17.46-39-39 17.46-39 39-39 39 17.46 39 39m-54.6 0c0 8.616 6.984 15.6 15.6 15.6s15.6-6.984 15.6-15.6-6.984-15.6-15.6-15.6-15.6 6.984-15.6 15.6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    d: "M81.667 41c0 21.54-17.461 39-39 39s-39-17.46-39-39 17.46-39 39-39 39 17.46 39 39m-54.6 0c0 8.616 6.984 15.6 15.6 15.6s15.6-6.984 15.6-15.6-6.984-15.6-15.6-15.6-15.6 6.984-15.6 15.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M81.667 41c0 21.54-17.461 39-39 39s-39-17.46-39-39 17.46-39 39-39 39 17.46 39 39Zm-54.6 0c0 8.616 6.984 15.6 15.6 15.6s15.6-6.984 15.6-15.6-6.984-15.6-15.6-15.6-15.6 6.984-15.6 15.6Z",
    mask: "url(#PieChartImg_svg__b)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "PieChartImg_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.667 2a39 39 0 0 1 38.31 31.692L57.99 38.077A15.6 15.6 0 0 0 42.667 25.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M42.667 2a39 39 0 0 1 38.31 31.692L57.99 38.077A15.6 15.6 0 0 0 42.667 25.4z",
    mask: "url(#PieChartImg_svg__c)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "PieChartImg_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.667 2a39 39 0 0 1 24.86 8.95L52.61 28.98a15.6 15.6 0 0 0-9.944-3.58z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M42.667 2a39 39 0 0 1 24.86 8.95L52.61 28.98a15.6 15.6 0 0 0-9.944-3.58z",
    mask: "url(#PieChartImg_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "PieChartImg_svg__a",
    width: 84,
    height: 84,
    x: 0.667,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
};
export default SvgPieChartImg;